module.exports = __webpack_public_path__ + "static/media/internet_traffic_blueprint.80eb72b1.jpg";